import React from 'react';


const Contact = () => {
    return (
        <section>
         
            <div class="content mt-5">
                <div class="title text-white"><span>Contact Me</span></div>
            </div>
            <div className="container">
                <div className="row">
                    <div 
                     data-aos="fade-down-right"
                  
                     data-aos-delay="50"
                     data-aos-duration="1000"
                
                
                 
                     className="col-md-6">
                        <h4 className='lead text-white mt-5'>I am a dedicated and practicing <p className='line1'>Front-End/Full Stack development</p> with solid knowledge in different technologies and
                            self-motivated and hardworking for an opportunity to work in a challenging environment to prove my
                            skills and utilize my knowledge in the growth of the organization.
                            I am interested in working with any company that thinks my skill will be helpful for them. If you are looking for someone like me, please let me know. Or you can just 'say hi' to me. <br />
                          <div className='mt-5'>
                                <a href="https://github.com/JRnihar" target='_blank'><i class=" text-white icon fa-brands fa-github"></i></a><a href="https://niharmonirulislam@gmail.com" target='_blank'><i class="text-white ms-5 icon fa-solid fa-envelope"></i></a><a href="https://www.facebook.com/monirulislam.nihar" target='_blank'><i class=" ms-5 text-white icon fa-brands fa-facebook-square"></i></a><a href="https://www.linkedin.com/in/moinr/" target='_blank'><i class=" ms-5 text-white icon fa-brands fa-linkedin" target='_blank'></i></a><a href="https://wa.me/1571142002" target='_blank'><i class=" ms-5 text-white icon fa-brands fa-whatsapp"></i></a>
                        
                          </div>
                            </h4>
                      
                        <a href="https://niharmonirulislam@gmail.com"><button className='rounded mt-3 mb-5'>Contact Me</button></a>
                    </div> 
                     <div 
                          data-aos="fade-down-left"
                       
                          data-aos-delay="50"
                          data-aos-duration="1000"
                          
                          
                        
                        
                     className="col-md-6  mt-5"> 
                        <h2 className='text-white text-bold'>Email</h2>
                        <p className='text-white text-bold'>niharmonirulislam@gmail.com<small className='text-muted'> (Recommended)</small> </p>
                        <h2 className='text-white text-bold'>Address</h2>
                        <p className='text-white text-bold'>Chittagong,Bangladesh</p>
                        <h2 className='text-white text-bold'>Phone</h2>
                        <p className='text-white text-bold'>+88 01571142002 </p>
                        
                      
                       
                     </div>
                     </div>           
                    </div>
               
        </section>
    );
};

export default Contact;